import React, { useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { SearchIcon, XIcon } from 'lucide-react';
import { products } from '../../data/products';
import { formatPrice } from '../../utils/currency';
export function SearchBar() {
  const [query, setQuery] = useState('');
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (q.length < 2) return [];
    return products.filter(p => `${p.name} ${p.brand} ${p.specs.join(' ')}`.toLowerCase().includes(q)).slice(0, 6);
  }, [query]);
  const showPanel = focused && query.trim().length >= 2;
  return <div className="relative w-full" data-id="element-316" data-mp="bkktgu4yr6i3">
      <label htmlFor="site-search" className="sr-only" data-id="element-317" data-mp="1921cgtmrk3y8">
        Zoek producten
      </label>
      <SearchIcon className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-318" data-mp="14at5034zusnp" />
      <input ref={inputRef} id="site-search" type="search" value={query} onChange={e => setQuery(e.target.value)} onFocus={() => setFocused(true)} onBlur={() => setTimeout(() => setFocused(false), 150)} placeholder="Zoek thuisbatterijen, powerstations, panelen…" autoComplete="off" className="h-11 w-full rounded-lg border border-line bg-surface pl-10 pr-10 text-sm text-ink placeholder:text-muted focus:border-ink focus:bg-white focus:outline-none focus:ring-2 focus:ring-ink/10 [&::-webkit-search-cancel-button]:hidden" data-id="element-319" data-mp="c7gcz6rg1lpk" />
      {query && <button type="button" onClick={() => {
      setQuery('');
      inputRef.current?.focus();
    }} aria-label="Zoekopdracht wissen" className="absolute right-2 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-md text-muted hover:bg-line hover:text-ink" data-id="element-320" data-mp="3gnhjr5knakzo">
          <XIcon className="h-4 w-4" data-id="element-321" data-mp="2rt3c7ma11w1x" />
        </button>}

      <AnimatePresence data-id="element-322" data-mp="2mtgwn66q83py">
        {showPanel && <motion.div initial={{
        opacity: 0,
        y: -4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -4
      }} transition={{
        duration: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute left-0 right-0 top-full z-50 mt-2 overflow-hidden rounded-xl border border-line bg-white shadow-[0_16px_40px_-16px_rgba(14,26,36,0.25)]" data-id="element-323" data-mp="2mrnspynhzxln">
            {results.length === 0 ? <p className="px-4 py-5 text-sm text-muted" data-id="element-324" data-mp="31q7z5obp5vjs">
                Geen producten gevonden voor “<span className="font-medium text-ink" data-id="element-325" data-mp="2wrem1x0bo6k5">{query}</span>”
              </p> : <ul className="py-1.5" data-id="element-326" data-mp="3u6sixnk3bv0u">
                {results.map(p => <li key={p.id} data-id="element-327" data-mp="3u8vcuiod68au">
                    <Link to={`/product/${p.id}`} className="flex items-center gap-3 px-3 py-2 hover:bg-surface" onClick={() => setQuery('')} data-id="element-328" data-mp="3pfirchezehmb">
                      <img src={p.image} alt="" className="h-11 w-11 rounded-md bg-surface object-cover" data-id="element-329" data-mp="5lp1yhzkhxen" />
                      <span className="min-w-0 flex-1" data-id="element-330" data-mp="aifhn47gmqzj">
                        <span className="block truncate text-sm font-medium text-ink" data-id="element-331" data-mp="em3ofko9pijq">{p.name}</span>
                        <span className="block text-xs text-muted" data-id="element-332" data-mp="jl6wldzjo4vx">{p.specs.join(' · ')}</span>
                      </span>
                      <span className="text-sm font-semibold text-ink" data-id="element-333" data-mp="oiqagcsbyfnc">{formatPrice(p.price)}</span>
                    </Link>
                  </li>)}
              </ul>}
          </motion.div>}
      </AnimatePresence>
    </div>;
}